import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    neutral: {
      main: '#64748B',
      contrastText: '#fff',
    },
    white: {
      main: '#fff',
    },
    primary: {
      main: '#87CB16',
      contrastText: '#fff',
    },
  },
  typography: {
    h4: {
      fontSize: '1.5rem',
    },
    h5: {
      fontSize: '1.2rem',
      color: '#888',
    },
    h6: {
      fontSize: '1rem',
    },
    subtitle1: {
      color: '#888',
    },
    subtitle2: {
      color: 'red',
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.md-field--readonly': {
            backgroundColor: 'var(--md-field-readonly-bg, #f5f5f5)',
            cursor: 'default',
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        size: 'small',
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          '&.md-form-paper': {
            padding: 'var(--md-form-group-padding, 16px)',
            borderRadius: 'var(--md-form-paper-radius, 4px)',
          },
        },
      },
    },
  },
});

export default theme;
